module.exports = __webpack_public_path__ + "img/21.207350c0.png";